import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "./ui/dialog";
import { Button } from "./ui/button";
import { ScrollArea } from "./ui/scroll-area";
import { translations } from '../data/translations';

export const PrivacyDialog = ({ lang, children }) => {
  const t = translations[lang].footer.privacy;

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children || <Button variant="link" className="text-gray-500 hover:text-white p-0 h-auto font-normal text-sm">{t.link}</Button>}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] bg-zinc-950 border-zinc-800 text-white max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{t.title}</DialogTitle>
          <DialogDescription className="text-gray-400">
             Buffalo Grill House
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[400px] w-full pr-4 rounded-md border border-zinc-800 bg-zinc-900/50 p-4">
          <div className="space-y-4 text-sm text-gray-300 leading-relaxed whitespace-pre-line">
            {t.content}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
